export enum LabType {
    ExternalLims = 'ExternalLIMS'
}
